<div class="popup confirmDecisionPopup">
    <h1 class="confirmDecisionPopup-title _primary" [i18nKey]="'common.save.before.deactivate.popup.title'"></h1>

    <p class="confirmDecisionPopup-message" [i18nKey]="'common.save.before.deactivate.popup.message'"></p>

    <div class="confirmDecisionPopup-action">
        <button (click)="cancel()" class="button _cancel" [i18nKey]="'common.save.before.deactivate.popup.message.ignore'"></button>
        <button (click)="confirm()" class="button" [i18nKey]="'common.save.before.deactivate.popup.message.save'"></button>
    </div>
</div>
<div class="overlay"></div>
